import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=6837511b&scoped=true&"
import script from "./DataProtection.vue?vue&type=script&lang=js&"
export * from "./DataProtection.vue?vue&type=script&lang=js&"
import style0 from "./DataProtection.vue?vue&type=style&index=0&id=6837511b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837511b",
  null
  
)

export default component.exports